import ProcessIds from './process_ids';

export default class ProcessStoreItem {
	_uniqueStoreItemId;
	_processIds;
	_isMobile;
	_formStoreId;
	_processInstanceData;
	_displayFormResult;
	_displayFormHeader;
	_waitingForAction;
	_formResultMessages;
	_layoutState;
	_isCurrentProcess;
	_ticket;
	_language;
	_uuid;
	_isPublic;
	_gatewayUrl;
	_lecomBpmUrl;
	_actionEmail;
	_isECMLicenseFull;
	_highContrast;
	_timeZone;
	_dataPrintEnabled;
	_signPermission;

	constructor(storeItemProps = {}) {

		Object.keys(storeItemProps)
		.forEach((propName) => this[`_${propName}`] = storeItemProps[propName]);

		this._processIds = this._buildProcessIds(storeItemProps.processIds);
	}

	_buildProcessIds(processIds = {}) {
		return new ProcessIds(processIds);
	}

	get uniqueStoreItemId() {
		return this._uniqueStoreItemId;
	}

	set uniqueStoreItemId(value) {
		this._uniqueStoreItemId = value;
	}

	get processIds() {
		return this._processIds;
	}

	set processIds(value) {
		this._processIds = this._buildProcessIds(value);
	}

	get isMobile() {
		return this._isMobile;
	}

	set isMobile(value) {
		this._isMobile = value;
	}

	get formStoreId() {
		return this._formStoreId;
	}

	set formStoreId(value) {
		this._formStoreId = value;
	}

	get processInstanceData() {
		return this._processInstanceData;
	}

	set processInstanceData(value) {
		this._processInstanceData = value;
	}

	get displayFormResult() {
		return this._displayFormResult;
	}

	set displayFormResult(value) {
		this._displayFormResult = value;
	}

	get displayFormHeader() {
		return this._displayFormHeader;
	}

	set displayFormHeader(value) {
		this._displayFormHeader = value;
	}

	get waitingForAction() {
		return this._waitingForAction;
	}

	set waitingForAction(value) {
		this._waitingForAction = value;
	}

	get formResultMessages() {
		return this._formResultMessages;
	}

	set formResultMessages(value) {
		this._formResultMessages = value;
	}

	get layoutState() {
		return this._layoutState;
	}

	set layoutState(value) {
		this._layoutState = value;
	}

	get isCurrentProcess() {
		return this._isCurrentProcess;
	}

	set isCurrentProcess(value) {
		this._isCurrentProcess = value;
	}

	get actionEmail() {
		return this._actionEmail;
	}

	set actionEmail(value) {
		this._actionEmail = value;
	}

	get isECMLicenseFull(){
		return this._isECMLicenseFull;
	}

	set isECMLicenseFull(value){
		this._isECMLicenseFull = value;
	}

	get ticket() {
		return this._ticket;
	}

	set ticket(value) {
		this._ticket = value;
	}

	get language() {
		return this._language;
	}

	set language(value) {
		this._language = value;
	}

	get isTestMode() {
		return this._isTestMode;
	}

	set isCurrentProcess(value) {
		this._isTestMode = value;
	}

	get uuid() {
		return this._uuid;
	}

	set uuid(value) {
		this._uuid = value;
	}

	get isPublic() {
		return this._isPublic;
	}

	set isPublic(value) {
		this._isPublic = value;
	}

	get gatewayUrl() {
		return this._gatewayUrl;
	}

	set gatewayUrl(value) {
		this._gatewayUrl = value;
	}

	get lecomBpmUrl() {
		return this._lecomBpmUrl;
	}

	set lecomBpmUrl(value) {
		this._lecomBpmUrl = value;
	}

	get highContrast() {
		return this._highContrast;
	}

	set highContrast(value) {
		this._highContrast = value;
	}

	get timeZone() {
		return this._timeZone;
	}

	set timeZone(value) {
		this._timeZone = value;
	}

	get dataPrintEnabled() {
		return this._dataPrintEnabled;
	}

	set dataPrintEnabled(value) {
		this._dataPrintEnabled = value;
	}

	get signPermission(){
		return this._signPermission;
	}

	set signPermission(value){
		this._signPermission = value;
	}
}
